<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-store-details__grid">
      <app-store-details-header
        [company_id]="company_id"
        [store_id]="store_id"
        (tab_change)="onTabChange($event)"
        (refresh)="onRefresh()"></app-store-details-header>

      <app-store-details-general
        *ngIf="current_tab === tabs.get('article')"
        [company_id]="company_id"
        [store_id]="store_id"></app-store-details-general>

      <app-store-details-team-data
        *ngIf="current_tab === tabs.get('group')"
        [company_id]="company_id"
        [store_id]="store_id"></app-store-details-team-data>

      <app-store-details-order-data
        *ngIf="current_tab === tabs.get('receipt_long')"
        [store_id]="store_id"></app-store-details-order-data>

      <app-store-details-event-data
        *ngIf="current_tab === tabs.get('timeline')"
        [company_id]="company_id"
        [store_id]="store_id"></app-store-details-event-data>

      <app-store-details-pending-invitations-data
        *ngIf="current_tab === tabs.get('mail_outline')"
        [store_id]="store_id"></app-store-details-pending-invitations-data>
    </div>
  </div>
</div>
